module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row user-data"
  }, [_c('div', {
    staticClass: "col s5 l12 user-avatar"
  }, [_c('img', {
    staticClass: "circle responsive-img",
    attrs: {
      "src": _vm.avatarUrl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col s7 l12 user-info"
  }, [_c('span', {
    staticClass: "full-name"
  }, [_c('span', {
    staticClass: "first-name"
  }, [_vm._v(_vm._s(_vm.getUser.first_name))]), _vm._v(" "), _c('span', {
    staticClass: "last-name"
  }, [_vm._v(_vm._s(_vm.getUser.last_name))])]), _vm._v(" "), _c('p', {
    staticClass: "user-email"
  }, [_vm._v(_vm._s(_vm.getUser.email))])]), _vm._v(" "), (!_vm.showForRole('accountant')) ? _c('div', {
    staticClass: "col s12 m12 l12 share-code"
  }, [_vm._m(0), _vm._v(" "), _c('input-promo-url', {
    attrs: {
      "type": "text",
      "name": "promo_url",
      "label": "Kod do promowania"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('Loader', {
    attrs: {
      "loading": _vm.getUserPending,
      "type": ""
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "mfind-icon-info icon"
  }), _vm._v("\n      Link do produktu\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1593cbba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/userInfo.vue
// module id = 361
// module chunks = 0